import React from 'react';
import { connect } from 'react-redux';
import './Spinner.css';

const overlayStyle = {
  position: 'fixed', 
  top: 0, 
  left: 0, 
  width: '100%', 
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  background: 'rgba(255,255,255,.8)',
  color: 'white',
  fontSize: 'small',
  transition: '300ms',
  zIndex: 99
};

const Spinner = ({text, show}) => {
  return (
    show? (
      <div style={overlayStyle}>
        <div style={{flexShrink: 0, width: '100%', textAlign: 'center'}}>
          <div className="loader"></div>
          <div style={{color: '#555'}}>{text}</div>
        </div>
      </div>
    ): null
  );
};

const mapStateToProps = (state) => (
  {
    text: state.ftp.spinner.text,
    show: state.ftp.spinner.show
  }
);

export default connect(mapStateToProps)(Spinner);